import React, { HTMLProps } from 'react';
import ReactTooltip, { Place } from 'react-tooltip';

export const Tooltip: React.FC<
    { tooltipTitle: string; tooltipText: string; tooltipId: string; place?: Place } & HTMLProps<HTMLDivElement>
> = ({ className, tooltipId, tooltipTitle, tooltipText, place, children }) => {
    return (
        <div className={className}>
            <div data-tip data-for={tooltipId} className="p-2">
                {children}
            </div>
            <ReactTooltip
                id={tooltipId}
                className="tooltip w-52 md:w-96"
                border={true}
                borderColor="#EABB40"
                backgroundColor="white"
                effect="solid"
                textColor="black"
                place={place}
            >
                <div className="text-left py-2 ">
                    <div className="text-base sm:text-lg pb-2 font-semibold">{tooltipTitle}</div>
                    <div className="text-xs sm:text-sm font-normal">{tooltipText}</div>
                </div>
            </ReactTooltip>
        </div>
    );
};

// border = {true}
